import { render, staticRenderFns } from "./new4.vue?vue&type=template&id=558a8698&"
import script from "./new4.vue?vue&type=script&lang=js&"
export * from "./new4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports